import React from 'react';
import { Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import InventoryAdjustmentDetailPage from 'pages/inventory-adjustment/adjustment-details/InventoryAdjustment';
import AdjustmentListPage from 'pages/inventory-adjustment/adjustment-list/AdjustmentListPage';

import {
  INVENTORY_ADJUSTMENT_ROOT,
  INVENTORY_ADJUSTMENT_ROUTES,
} from './constants';

export const useInventoryAdjustmentRouter = (): React.JSX.Element => (
  <Route
    path={INVENTORY_ADJUSTMENT_ROOT}
    element={<PrivateRoute roles={[UserRolesEnum.SUPER_ADMIN]} />}
  >
    <Route
      path={INVENTORY_ADJUSTMENT_ROUTES.LIST_PAGE}
      element={<AdjustmentListPage />}
    />
    <Route
      path={INVENTORY_ADJUSTMENT_ROUTES.DETAILS}
      element={<InventoryAdjustmentDetailPage />}
    />
  </Route>
);
